<div class="layout-row layout-align-center-center full-height">
  <div class="spinner-border" role="status">
    <span class="sr-only"></span>
  </div>
</div>
